ACDiscountApp.CartPage.Show_CalculateTier = function () {
   let TierProducts = [];
  var postDataDiscountArrayObject = [];
  var discountMsg = "TIERED_DISCOUNT";

  // Utility function to create a discount object, used in all three discount types.
  function createDiscountObject(msg, variantId, value) {
    return {
      message: msg,
      targets: [{ productVariant: { id: variantId } }],
      value: value,
    };
  }

  // Creates a percentage discount object as per Shopify requirements.
  function createPercentageDiscountObject(msg, percentage, variantId) {
    return createDiscountObject(msg, variantId, {
      percentage: { value: percentage },
    });
  }

  // Creates a fixed amount discount object and calculates the total discount amount.
  function createAmountOffDiscountObject(
    msg,
    variantId,
    currencyRate,
    amount,
    qtys
  ) {
    const totalDiscountedAmount = (amount * currencyRate * qtys).toFixed(2);
    return createDiscountObject(msg, variantId, {
      fixedAmount: { amount: totalDiscountedAmount },
    });
  }

  // Creates a discounted price object and calculates the discount based on the original price.
  function createDiscountedPriceDiscountObject(
    msg,
    variantId,
    currencyRate,
    amount,
    qtys,
    price
  ) {
    const discountAmount = (amount * currencyRate).toFixed(2);
    if (price > discountAmount) {
      const discountValue = (price - discountAmount).toFixed(2);
      const totalDiscountedAmount = (discountValue * qtys).toFixed(2);

      return createDiscountObject(msg, variantId, {
        fixedAmount: { amount: totalDiscountedAmount },
      });
    }

    // Return null or a default value if no discount applies (optional based on your use case)
    return null;
  }

  async function setDateTimeInCart() {
    try {
      // JSON.stringify(postDataDiscountArrayObject)
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            Discountly_dateTime: JSON.stringify(postDataDiscountArrayObject),
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
       jQuery(".loading-overlay").addClass("hidden");
      await fetch("/cart.js").then((r) =>
        r.json().then((data) => ({ status: r.status, body: data }))
      );
    } catch (error) {
      // console.error('Failed to update cart:', error);
    }
  }
  
  // Item and line Item Price Selector;
   var cartPageItemPrice = '.product-option.product-orignal-price';
   var cartPageLineItemPrice = '.cart-item__totals.right.small-hide';

   var drawerItemPrice = '.cart-item-list.cart-drawer__content-item .cart-item__column.cart-item__price';
   var drawerLineItemPrice = '.drawer__cart-items-wrapper .cart-item__details .cart-item__discounted-prices';
  
    // Cart Total Selector Drawer and cart page;
   var cartPageCartTotalPrice = '.cart__footer .cart__blocks .totals__total-value';

   var drawerCartTotalPrice = '.cart-drawer__footer .theme-money';

   // Saving Message 
   var savingMessageCartPage = '.cart__footer .totals';
    // CheckOut Button;
   var checkoutButtonCartPage = '.cart__footer button[name="checkout"]';
   
   var checkoutButtonDrawerPage = '#cart-notification-form button[name="checkout"]';


   var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index) {
      if (isUpdate) {
      var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
      var condition1 = updatedItemPrice == originalItemPrice;
      updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);
      if (isNotInRange || condition1) {
      jQuery(cartPageItemPrice).eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(drawerItemPrice).eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(cartPageLineItemPrice).eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
      jQuery(drawerLineItemPrice).eq(index).html('<span><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></span>');
      }
      else {
      originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
      jQuery(`.item_${item.variant_id} .discountTitle`).text(discountMsg);
      jQuery(`.item_${item.variant_id}`).show();
      jQuery(cartPageItemPrice).eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(drawerItemPrice).eq(index).html('<div class="cart-item__original-price "><s><span class="money cart-item__selling-price" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class=" cart-item__selling-price money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(cartPageLineItemPrice).eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></div> <div style="margin-left:5px"><span class="cart-item__selling-price money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
      jQuery(drawerLineItemPrice).eq(index).html('<span class="cart-item__original-price"><s><span class="money theme-money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></span> <span><span class="theme-money money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></span>');
      }
      }
     jQuery('.cart-item__item-discounts').hide()
}

  var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
    if (isUpdate) {
        updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
        if (originalTotalPrice != updatedTotalPrice) {
            jQuery(drawerCartTotalPrice).html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            jQuery(cartPageCartTotalPrice).html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
        }
        else {
        jQuery(drawerCartTotalPrice).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
        jQuery(cartPageCartTotalPrice).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
        }
    }
}

  var UpdateSavingMessage = function (isUpdate) {
    if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
        var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
        var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
      if (jQuery(window).width() < 700) {
        jQuery('#saved-banner-div').length == 0 ? jQuery(savingMessageCartPage).after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
      }
      else{
        jQuery('#saved-banner-div').length == 0 ? jQuery(savingMessageCartPage).after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
      }
    }
    else if (globalFields.isCartPage) {
        jQuery('#saved-banner-div').remove();
    }
}

  var CheckoutClickCart = function () {
  function CallGetCodecart() {// this is only for cart page
      TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
     // GetCode(false);
  }
  jQuery(checkoutButtonCartPage).once('click', CallGetCodecart);
  }

  var CheckoutClickAjax = function () {
 function CallGetCodeAjax() {// this is  only for ajax and drawer 
     //GetCode(true);
 }
 jQuery(checkoutButtonDrawerPage).once('click', CallGetCodeAjax);
}

jQuery.fn.once = function(a, b) {
   return this.each(function() {
    jQuery(this).off(a).on(a,b);
   });
 };


 var GetCode = function (isUpper) {
    if (priceDiff > 0) {
        jQuery.ajax({
            type: "POST", async: false, url: "https://customerapp.anncode.com/tier/ACPGenerateDiscountCode",
            data: { priceDifference: priceDiff, subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString() },
            success: function (result) {
                var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
                var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
                SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                if (!isUpper) {
                    DiscountCodeCookie(DiscountCode);
                    jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                      window.location.href = '/checkout?discount=' + DiscountCode;
                } else {
                    DiscountCodeCookie(DiscountCode);
                    //jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                    window.location.href = '/checkout?discount=' + DiscountCode;
                }
            },
            error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
        });
    }
    else if (isUpper) {
        window.location.href = '/checkout';
    }
  else{
    window.location.href = '/checkout';
  }
}

 var ReInvokeAjaxCartButton = function () {
    jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
 }

var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;
  var hide_buttons = null;
  var HideAdditionalPayments = function() {      
  hide_buttons = setInterval(function() {
    if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
      jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
      clearInterval(hide_buttons);
    }
  }, 500);
}
 var variantIdsToSend = [],
    minimumDiscountSubtotal = 0,
    priceDiff = 0;
var TieredPricingCart = function (cartObject, isUpdate) {
    variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;
  TierProducts = [];postDataDiscountArrayObject = [];
    for (var k = 0; k < cartObject.items.length; k++) {
        var item = cartObject.items[k], isInRange = true, itemTiers = GetTiersFromTiersArray(item.variant_id);
      if (itemTiers != undefined && itemTiers.status && globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
        
        let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
        let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
           if(DiscountAppliedOn){
            if(Location_Tag_s){
               let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
               let LocationObject = Object.keys(itemTiers.Location_Tag_);
               if(LocationObject[0] == 'StoreLocation'){
                let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                if(StoreLocationcheck && DiscountAppliedOnTag){
                    var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                    updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                    if (rslt[1]) {
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                    }
                  }else{
                  updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
               }else{
               let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
               let CusotmerCountryLocation = globalFields.Customercountry;
               let CusotmerCityLocation = globalFields.Customercity;
               let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
               let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
               let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
               let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                 if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                    var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                    updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                    if (rslt[1]) {
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                    }
                 }else{
                   updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
               }
                                               
             }else{
              if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
               var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
              updatedTotalPrice = rslt[0]; isInRange = rslt[1];
              if (rslt[1]) {
              updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
              }
             }else{
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
             }
             }
             
           }
           else{
            var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
            updatedTotalPrice = rslt[0]; isInRange = rslt[1];
            if (rslt[1]) {
            updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            }
           }
         }
        else {
         UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), true, true, k);
         updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
        }
      
        if (!isInRange) {
            minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
        }
    }
    UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
    priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
    UpdateSavingMessage(isUpdate);
    setDateTimeInCart();
    jQuery('#cart-notification button[name="checkout"],.drawer__footer button[name="checkout"]').text('\n            Check out\n          ');
    jQuery('.cart__checkout-button.button').text('\n            Check out\n          ');
      if(priceDiff){
      HideAdditionalPayments();
    }
      setTimeout(function(){
      clearInterval(hide_buttons);
    }, 5000);
}
setTimeout(function(){
  clearInterval(hide_buttons);
}, 10000);

var GetTiersFromTiersArray = function (variantId) {
    var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
    if (tierObj == undefined || tierObj[0].tiers == "[]") {
        return undefined;
    }
    else {
        return globalFields.GetTierObject(tierObj[0].tiers[0], variantId);
    }
}

var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
    let isFound = TierProducts.some(element => {if (element.VarientID === item.variant_id) { return true;}return false;});
    for (var i = 0; i < itemTiers.tier_min.length; i++) {
        var allVariantItemQty = 0;
        var tierPrice = parseFloat(itemTiers.tier_values[i]);
       let tempTierProductsobj = {};
           let postDataDiscountObject = {};
        var minTier = parseInt(itemTiers.tier_min[i]), maxTier = itemTiers.tier_max[i] != 'max' ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
        var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;

        if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
            var tempItemArray = [];
            if (itemTiers.entity_type === 'collections') {
                var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].entity_id == itemTiers.entity_id); });
                for (var m = 0; m < tempTierArray.length; m++) {
                    var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                    if (temp.length != 0) {
                        tempItemArray.push(temp[0]);
                    }
                }
            }
            else {
                tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
            }

            for (var j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
            condition1 = allVariantItemQty >= minTier;
            condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
        }
        else {
            condition1 = item.quantity >= minTier;
            condition2 = maxTier == "max" || item.quantity <= maxTier;
        }

        if (condition1 && condition2) {
         
             var Vid = `gid://shopify/ProductVariant/${item.variant_id}`;
              var currencyRate = Shopify.currency.rate;
              var qtys = item.quantity;
              var price = Number(item.original_price / 100).toFixed(2);
                isNotInRange = false;
            if (itemTiers.discount_type == 'percentage') {
                var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)));
                updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
            
             if(!isFound){
                        tempTierProductsobj['Discountvalue'] = tierPrice;
                        tempTierProductsobj['DiscountType'] = itemTiers.discount_type;
                        tempTierProductsobj['VarientID'] = item.variant_id;
                        discountMsg = itemTiers?.discountCouponTitle ?? 'TIERED_DISCOUNT';
                      let resposne = createPercentageDiscountObject(discountMsg,tierPrice,Vid);
                      postDataDiscountObject = resposne;
                    }  
            }
            else if (itemTiers.discount_type == 'fixed') {
                updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice));
              if(!isFound){
                discountMsg = itemTiers?.discountCouponTitle ?? 'TIERED_DISCOUNT';
                      let resposne = createAmountOffDiscountObject(discountMsg,Vid,currencyRate,tierPrice, qtys);
            postDataDiscountObject = resposne;
            tempTierProductsobj["Discountvalue"] = postDataDiscountObject.value.fixedAmount.amount;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = `gid://shopify/ProductVariant/${item.variant_id}`;
                    }
            }
            else if (itemTiers.discount_type == 'fixed_price') {
                updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
             if(!isFound){
            tempTierProductsobj["Discountvalue"] = tierPrice;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = `gid://shopify/ProductVariant/${item.variant_id}`;
               discountMsg = itemTiers?.discountCouponTitle ?? 'TIERED_DISCOUNT';
            let resposne = createDiscountedPriceDiscountObject(discountMsg, Vid,currencyRate,tierPrice,qtys,price);
            postDataDiscountObject = resposne;
                    } 
            }

             if (updatedItemPrice < 0) { updatedItemPrice = 0; }
                if(updatedItemPrice <= item.original_price/100){
                    updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                    UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index);
             }else{isNotInRange = true}
        if (!isFound) {
          if (postDataDiscountObject != null) {
            postDataDiscountArrayObject.push(postDataDiscountObject);
          TierProducts.push(tempTierProductsobj);
          }
        }
            }
        }
    if (isNotInRange) {
        UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
    }
    return [updatedTotalPrice, isNotInRange];
}

var DiscountCodeCookie = function (discount_code) {
    jQuery.ajax({
        type: "HEAD", url: "/discount/" + discount_code,
        success: function (_result) { },
        error: function (e) { console.log(e.statusText); }
    })
}

   var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
                CheckoutClickAjax();
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
jQuery(document).ajaxComplete(function (event, xhr, settings) {
    ProcessCartResponse(settings?.url, xhr?.responseText);
});

var ProcessCartResponse = function (splittedUrl, responseText) {
    if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
        splittedUrl = splittedUrl.split("?");
        if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
             jQuery('#cart-notification button[name="checkout"],.drawer__footer button[name="checkout"]').text('\n            Loading...\n          ');
             jQuery('.cart__checkout-button.button').text('\n            Loading...\n          ');
            globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
            setTimeout(function () {
                FetchCartTiers();
                CheckoutClickAjax();
            }, 1200);
        }
    }
}

try {
    var nativeFetch = window.fetch;
    window.fetch = function (...args) {
        try {
            if (typeof args[0] === 'string' && (args[0].includes("/cart/change") || args[0].includes("/cart/add") || args[0].includes('_cart-drawer'))) {
                setTimeout(function () {
                    fetch('/cart.js')
                        .then(r => r.json().then(data => ({ status: r.status, body: data })))
                        .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
                }, 800);
            }
        } catch (err) {
            console.error("Error in intercepting fetch:", err);
        }
        return nativeFetch.apply(window, args);
    }
} catch (e) {
    console.error("Error in overriding fetch:", e);
}


 var CheckoutClickAjaxPopUp = function () {
   FetchCartTiers();
 }
 async function handleDiscount() {
     try {
       const response = await fetch("/discount/CLEAR");
   
       if (!response.ok) {
         throw new Error(`HTTP error! Status: ${response.status}`);
       }
   
       const contentType = response.headers.get("Content-Type");
   
       if (contentType && contentType.includes("application/json")) {
         const data = await response.json();
         // Continue processing or updating the UI as needed
       } else {
         // Handle non-JSON content, such as HTML or other types
         // console.error("Unexpected content type:", contentType);
         // Handle specific error scenarios or display a user-friendly message
       }
     } catch (error) {
       // Handle errors
       // console.error("Error fetching discount:", error.message);
       // Handle specific error scenarios or display a user-friendly message
     }
   }
   // Call the function to initiate the fetch and handle the promise
   handleDiscount();
 var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();CheckoutClickAjaxPopUp();
}

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();